"use strict";

exports.__esModule = true;
exports["default"] = exports.NextButton = exports.Next = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _utils = require("../../utils");

var _slider = _interopRequireDefault(require("../../components/slider"));

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["isActive"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NextButton = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "tools-slider__NextButton",
  componentId: "sc-vk9yqr-0"
})(["transform:translateY(-50%);box-shadow:0 4px 16px 0 ", ";"], function (props) {
  return (0, _styles.themeTransparentize)(0.8, "background-dark")(props);
});
exports.NextButton = NextButton;
var IconContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "tools-slider__IconContainer",
  componentId: "sc-vk9yqr-1"
})(["", ";opacity:", ";"], (0, _styles.defaultTransition)(["opacity"]), function (props) {
  return props.disabled ? "0.3" : "1";
});
var propTypesButton = {
  /** Boolean prevents onClick */
  disabled: _propTypes.bool,

  /** onClick handler */
  onClick: _propTypes.func
};

var Next = function Next(_ref) {
  var disabled = _ref.disabled,
      _onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(NextButton, {
    backgroundColor: "background",
    borderRadius: "5px 0 0 5px",
    cursor: "pointer",
    disabled: disabled,
    fill: "icon-input",
    height: 80,
    onClick: function onClick() {
      if (!disabled) {
        _onClick();
      }
    },
    position: "absolute",
    right: 0,
    top: "50%",
    width: 50
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    height: 1,
    justifyContent: "center",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(IconContainer, {
    disabled: disabled,
    display: "block",
    forwardedAs: "span",
    height: 32,
    width: 32
  }, /*#__PURE__*/_react["default"].createElement(_components.NavCaretRight, null))));
};

exports.Next = Next;
Next.propTypes = propTypesButton;
var PrevButton = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "tools-slider__PrevButton",
  componentId: "sc-vk9yqr-2"
})(["transform:translateY(-50%);box-shadow:0 4px 16px 0 ", ";"], function (props) {
  return (0, _styles.themeTransparentize)(0.8, "background-dark")(props);
});

var Prev = function Prev(_ref2) {
  var disabled = _ref2.disabled,
      _onClick2 = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement(PrevButton, {
    backgroundColor: "background",
    borderRadius: "5px 0 0 5px",
    cursor: "pointer",
    disabled: disabled,
    fill: "icon-input",
    height: 80,
    left: 0,
    onClick: function onClick() {
      if (!disabled) {
        _onClick2();
      }
    },
    position: "absolute",
    top: "50%",
    width: 50
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    height: 1,
    justifyContent: "center",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(IconContainer, {
    disabled: disabled,
    display: "block",
    forwardedAs: "span",
    height: 32,
    width: 32
  }, /*#__PURE__*/_react["default"].createElement(_components.NavCaretLeft, null))));
};

Prev.propTypes = propTypesButton;
var SliderDot = (0, _styledComponents["default"])(function (_ref3) {
  var isActive = _ref3.isActive,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "tools-slider__SliderDot",
  componentId: "sc-vk9yqr-3"
})(["cursor:pointer;display:inline-block;border-radius:50%;border:1px solid ", ";", " &:last-child{margin:0;}"], function (props) {
  return (0, _styles.colors)("icon", props);
}, function (props) {
  return props.isActive ? "background-color: " + (0, _styles.colors)("icon", props) + ";" : "";
});
var PositionDotsContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "tools-slider__PositionDotsContainer",
  componentId: "sc-vk9yqr-4"
})(["position:absolute;left:0;"]);

var DotsContainer = function DotsContainer(props) {
  return /*#__PURE__*/_react["default"].createElement(PositionDotsContainer, _extends({
    alignItems: "center",
    justifyContent: "center",
    width: 1
  }, props));
};

var propTypesDot = {
  /** Boolean determines isActive */
  active: _propTypes.bool,

  /** onClick handler */
  onClick: _propTypes.func
};

var Dot = function Dot(_ref4) {
  var active = _ref4.active,
      onClick = _ref4.onClick;
  return /*#__PURE__*/_react["default"].createElement(SliderDot, {
    height: 14,
    isActive: active,
    mr: 1,
    onClick: onClick,
    width: 14
  });
};

Dot.propTypes = propTypesDot;
var propTypesControls = {
  /** children node for Slider controls */
  children: _propTypes.node
};

var Controls = function Controls(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    height: 14,
    justifyContent: "center",
    pb: 4,
    pt: 5
  }, children);
};

Controls.propTypes = propTypesControls;

var settings = function settings(single) {
  return {
    customControls: Controls,
    customDots: Dot,
    customDotsContainer: DotsContainer,
    nextArrow: Next,
    overflowVisible: true,
    prevArrow: Prev,
    responsive: [{
      breakpoint: 0,
      teardown: true
    }, {
      breakpoint: 550,
      slidesToShow: single ? 1 : 2,
      teardown: true
    }, {
      breakpoint: 950,
      slidesToChange: single ? 1 : 2,
      slidesToShow: single ? 1 : 2
    }, {
      breakpoint: 1440,
      slidesToChange: 3,
      slidesToShow: single ? 1 : 3
    }]
  };
};

var OverflowSlider = (0, _styledComponents["default"])(_slider["default"]).withConfig({
  displayName: "tools-slider__OverflowSlider",
  componentId: "sc-vk9yqr-5"
})(["position:static;"]);
var wrapperProps = {
  direction: ["column", "row"],
  flexWrap: ["wrap", "wrap", "nowrap", "nowrap"]
};
var propTypes = {
  /** tool items cards passed as children */
  children: _propTypes.node,

  /** Boolean determines card styles */
  single: _propTypes.bool,

  /** Width style prop  */
  width: _utils.stylePropType
};

var ToolsSlider = function ToolsSlider(_ref6) {
  var width = _ref6.width,
      children = _ref6.children,
      single = _ref6.single;
  return /*#__PURE__*/_react["default"].createElement(OverflowSlider, _extends({
    alignItems: "stretch",
    flexDirection: "column",
    justifyContent: "stretch",
    wrapperProps: Object.assign({}, wrapperProps, {
      width: width
    })
  }, settings(single)), children);
};

ToolsSlider.propTypes = propTypes;
ToolsSlider.displayName = "Modules.ToolsSlider";
var _default = ToolsSlider;
exports["default"] = _default;